import { motion } from 'framer-motion';
import { Star, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export const ServiceCard = ({ service, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay: index * 0.1 }}
      className="service-card group"
      data-testid={`service-card-${service.id}`}
    >
      <Link to={`/service/${service.id}`} className="block">
        <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow border border-blue-100/50">
          {/* Image */}
          <div className="relative h-48 overflow-hidden">
            <img
              src={service.image}
              alt={service.name}
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent" />
            
            {/* Rating Badge */}
            <div className="absolute top-4 right-4 flex items-center gap-1 bg-white/90 backdrop-blur-sm px-3 py-1.5 rounded-full">
              <Star size={14} className="text-yellow-500 fill-yellow-500" />
              <span className="text-sm font-semibold text-slate-700">{service.rating}</span>
            </div>
            
            {/* Category */}
            <div className="absolute bottom-4 left-4">
              <span className="text-xs font-medium text-white/80 bg-white/20 backdrop-blur-sm px-3 py-1 rounded-full">
                {service.category}
              </span>
            </div>
          </div>

          {/* Content */}
          <div className="p-5">
            <h3 className="text-lg font-bold text-slate-800 mb-2 group-hover:text-blue-600 transition-colors font-['Oswald']">
              {service.name}
            </h3>
            <p className="text-sm text-slate-600 mb-4 line-clamp-2">
              {service.shortDesc}
            </p>
            
            {/* CTA */}
            <div className="flex items-center justify-between">
              <span className="text-blue-600 font-medium text-sm flex items-center gap-1 group-hover:gap-2 transition-all">
                View Details
                <ArrowRight size={16} />
              </span>
            </div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};
